// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-module_modalContainer__wA1AX {
    background-color: var(--white);
    bottom: 0;
    left: 0;
    min-width: 288px;
    position: fixed;
    right: 0;
    top: 0;
    z-index: var(--zindex-modal-index);
}

.modal-module_modalViewport__Nlv6K {
    background-color: var(--white);
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    overflow-x: hidden;
    overflow-y: auto;
}

.modal-module_modalBody__D0n22 {
    padding: 72px 0 0 0;
    margin: 0 auto;
    max-width: 100%;
    min-height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    @media screen and (min-width: 481px) {
        max-width: 480px;
    }

    @media screen and (min-width: 708px) {
        padding: 104px 0;
        max-width: calc(((100% - 168px) / 6) * 4 + 120px);
    }

    @media screen and (min-width: 889px) {
        max-width: 600px;
    }
}

.modal-module_noTopPadding__DgE4M {
    padding: 0 0 64px 0;
    @media screen and (min-width: 708px) {
        padding: 0 0 104px 0;
    }
}

.modal-module_isVerticalCentered__fve9x {
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/UI/Modal/modal.module.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,eAAe;IACf,QAAQ;IACR,MAAM;IACN,kCAAkC;AACtC;;AAEA;IACI,8BAA8B;IAC9B,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;;IAE3B;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,iDAAiD;IACrD;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,mBAAmB;IACnB;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":[".modalContainer {\n    background-color: var(--white);\n    bottom: 0;\n    left: 0;\n    min-width: 288px;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: var(--zindex-modal-index);\n}\n\n.modalViewport {\n    background-color: var(--white);\n    bottom: 0;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.modalBody {\n    padding: 72px 0 0 0;\n    margin: 0 auto;\n    max-width: 100%;\n    min-height: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n\n    @media screen and (min-width: 481px) {\n        max-width: 480px;\n    }\n\n    @media screen and (min-width: 708px) {\n        padding: 104px 0;\n        max-width: calc(((100% - 168px) / 6) * 4 + 120px);\n    }\n\n    @media screen and (min-width: 889px) {\n        max-width: 600px;\n    }\n}\n\n.noTopPadding {\n    padding: 0 0 64px 0;\n    @media screen and (min-width: 708px) {\n        padding: 0 0 104px 0;\n    }\n}\n\n.isVerticalCentered {\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContainer": `modal-module_modalContainer__wA1AX`,
	"modalViewport": `modal-module_modalViewport__Nlv6K`,
	"modalBody": `modal-module_modalBody__D0n22`,
	"noTopPadding": `modal-module_noTopPadding__DgE4M`,
	"isVerticalCentered": `modal-module_isVerticalCentered__fve9x`
};
export default ___CSS_LOADER_EXPORT___;
